import { Button } from '#/components/Button/Button';
import { SaveListingButton } from '#/components/SaveButton/SaveListingButton';
import { ShareListingButton } from '#/components/ShareListingButton/ShareListingButton';
import { useI18n } from '#/i18n/hooks/useI18n';
import { ListingActionsDropdown } from '#/modules/listing/components/ListingActionsDropdown/ListingActionsDropdown';
import type { ApiOrg } from '#/modules/listing/orgs/api/types/ApiOrg';
import { OrgMemberButton } from '#/modules/listing/orgs/components/OrgMemberButton';
import { spacing } from '#/theme/theme';
import { trackClicked } from '#/utils/analytics/track/trackClicked';

import { orgHasListings } from './utils/orgHasListings';

type Props = {
  org: ApiOrg;
  isPreview: boolean;
  mobile: boolean;

  // Save
  saved: boolean;
  onSave: () => Promise<void>;
  onUnsave: () => Promise<void>;

  // Join org (groups only, hidden for the org's admins)
  orgMember?: {
    isMember: boolean;
    onJoin: () => void;
    onLeave: () => void;
  } | null;
};

export function ViewOrgPageActionButtons({
  org,
  isPreview,
  mobile,
  saved,
  onSave,
  onUnsave,
  orgMember = null,
}: Props) {
  const { i18n } = useI18n();

  return (
    <div style={{ display: 'flex', gap: spacing[8], alignItems: 'center' }}>
      {orgMember && (
        <OrgMemberButton
          orgId={org.id}
          isMember={orgMember.isMember}
          disabled={isPreview}
          onJoin={orgMember.onJoin}
          onLeave={orgMember.onLeave}
        />
      )}

      {orgHasListings(org) && (
        <Button
          type="link"
          href="#opportunities"
          variant="primary"
          onClick={() =>
            trackClicked('See Opportunities', { type: 'Button Top' })
          }
        >
          {i18n('See opportunities')}
        </Button>
      )}

      <SaveListingButton
        listingType="ORG"
        disabled={isPreview}
        listingSaved={saved}
        onSaveListing={onSave}
        onUnsaveListing={onUnsave}
        orgDetails={null}
      />

      {!mobile && (
        <ShareListingButton
          listingId={org.id}
          listingType="ORG"
          listingUrl={org.url}
          disabled={isPreview}
        />
      )}

      <ListingActionsDropdown
        listingId={org.id}
        listingType="ORG"
        listingUrl={org.url}
        orgDetails={null}
        markAsAppliedButton={null}
      />
    </div>
  );
}
